/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AppUtils } from '../../core/AppUtils';
import { CLOCK_REFRESH_RATE } from '../../config';
import { ClockProps } from './ClockProps';

import './Clock.scss';

const Clock: FunctionComponent<ClockProps> = ({ type }): JSX.Element => {
    const [currentTime, setCurrentTime] = useState(AppUtils.formatTime(new Date()));
    const refreshClock = () => {
        setCurrentTime(AppUtils.formatTime(new Date()));
    };

    useEffect(() => {
        const timeoutId = setInterval(refreshClock, CLOCK_REFRESH_RATE);
        return () => {
            clearInterval(timeoutId);
        };
    }, [currentTime]);

    return (
        <React.Fragment>
            <div className={type} data-testid="common-clock">
                {currentTime}
            </div>
        </React.Fragment>
    );
};

Clock.propTypes = {
    type: PropTypes.string,
};

export default Clock;
